<div class="donors">
  <img loading="lazy" class="donors-img" [attr.data-src]="supporterImg" alt="all supporters" />
  <span class="donor-count"><strong> {{subsCount?.monthlyDonors}}</strong> {{label}}</span>
</div>
